export default {
  noExportSettings: 'Žiadny z blokov tejto správy nepotrebuje nastavenia na export.',
};
